'use client';

import React, { useEffect, useRef } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { redactPostHogEmailAttribution } from '@ui/analytics/posthog-url-redaction';
import { announcePostHogClientReady } from '@ui/analytics/posthog-client-readiness';
import { prepareWebEmailAttributionBeforeTelemetry } from '@ui/analytics/email-notification-attribution';

interface CSPostHogProviderProps {
  children: React.ReactNode;
}

export function CSPostHogProvider({ children }: CSPostHogProviderProps) {
  const initRef = useRef(false);

  useEffect(() => {
    if (!initRef.current && typeof window !== 'undefined') {
      initRef.current = true;
      const suppressNotificationTelemetry = prepareWebEmailAttributionBeforeTelemetry();
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST_CREATOR || 'https://eu.i.posthog.com',
        person_profiles: 'identified_only',
        before_send: redactPostHogEmailAttribution,
        capture_pageview: false,
        capture_pageleave: false,
        disable_session_recording: suppressNotificationTelemetry,
        loaded: (posthog) => {
          announcePostHogClientReady();
          posthog.capture('$pageview', { $current_url: window.location.href });
          if (process.env.NODE_ENV === 'development') posthog.debug();
        },
      });
    }
  }, []);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
